
import {
    InMemoryCache
  } from 'apollo-cache-inmemory';

const cache = new InMemoryCache();

export { cache };
